import { ProfitAndLossVoucherRowsData } from "@/types/profit-and-loss-voucher-rows-api";
import RawDataTable from "../common/RawDataTable";
import LoadingPage from "../LoadingPage";
import { useTranslation } from "react-i18next";

interface ProfitAndLossRawDataProps {
    data: ProfitAndLossVoucherRowsData,
    showTitle?: boolean
}

const ProfitAndLossRawData = (data: ProfitAndLossRawDataProps) => {
    const { t } = useTranslation("common");
    if (!data.data) return <LoadingPage />;
    // const currentData = Array.from({ length: 1000 }, () => data.data).flat();
    const currentData = data.data;
    return (
        <div className="bg-white rounded-2xl w-full p-8 shadow-sm">
            <RawDataTable data={currentData} showTitle={data.showTitle} />
        </div>
    );
};

export default ProfitAndLossRawData;